/**
 * Scroll to a section by its id, offsetting for the sticky header.
 * Falls back to the globally exposed __scrollToSection helper if available.
 */
export const scrollToSection = (sectionId) => {
  // Try using the globally exposed scroll helper from SectionsPage first
  if (window.__scrollToSection) {
    window.__scrollToSection(sectionId);
    return;
  }

  // Fallback: scroll directly
  const element = document.getElementById(sectionId);
  if (element) {
    const headerOffset = 120;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};